document.querySelectorAll(".btn-size-chart").forEach(button => {
  button.addEventListener("click", function (e) {
    e.preventDefault();
    document.querySelector(".size-chart-popup").classList.toggle("open");
    document.querySelector("body").classList.add("overflow-hidden");
  });
});

document.querySelectorAll(".size-chart-popup .drawer__overlay, .size-chart-popup .drawer__close-button")
  .forEach(element => {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".size-chart-popup").classList.remove("open");
      document.querySelector("body").classList.remove("overflow-hidden");
    });
});

// document.addEventListener('DOMContentLoaded', function() {
//   const gridItems = document.querySelectorAll('.grid__item');
  
//   gridItems.forEach(gridItem => {
//     const productCard = gridItem.querySelector('.card-wrapper, .product-card-wrapper');
//     if (!productCard) return;
    
//     const link = productCard.querySelector('a');
//     if (!link) return;
    
//     const productHandle = link.href.split('/products/')[1]?.split('?')[0];
//     if (!productHandle) return;
    
//     fetch(`/products/${productHandle}.js`)
//       .then(res => res.json())
//       .then(product => {
//         console.log('Product:', product.title, 'Options:', product.options); // Debug
        
//         const colorOptionIndex = product.options.findIndex(opt => 
//           opt.name.toLowerCase().includes('color')
//         );
        
//         if (colorOptionIndex === -1) return;
        
//         const colorGroups = {};
//         product.variants.forEach(variant => {
//           const color = variant.options[colorOptionIndex];
//           if (!colorGroups[color]) {
//             colorGroups[color] = variant;
//           }
//         });
        
//         const colors = Object.keys(colorGroups);
        
//         colors.forEach((color, index) => {
//           const variant = colorGroups[color];
          
//           if (index === 0) {
//             updateGridItem(gridItem, product, variant, color);
//           } else {
//             const newGridItem = gridItem.cloneNode(true);
//             updateGridItem(newGridItem, product, variant, color);
//             gridItem.parentNode.insertBefore(newGridItem, gridItem.nextSibling);
//           }
//         });
//       })
//       .catch(error => {
//         console.error('Error fetching product:', error);
//       });
//   });
// });

// function updateGridItem(gridItem, product, variant, color) {
//   const img = gridItem.querySelector('img');
//   if (img && variant.featured_image) {
//     img.src = variant.featured_image.src;
//     img.srcset = variant.featured_image.src;
//     if (img.hasAttribute('srcset')) {
//       img.setAttribute('srcset', variant.featured_image.src);
//     }
//   }
  
//   const title = gridItem.querySelector('.card__heading, .card-information__text, h3, .product-title');
//   if (title) {
//     const titleLink = title.querySelector('a') || title;
//     titleLink.textContent = product.title + ' - ' + color;
//   }
  
//   const priceElement = gridItem.querySelector('.price-item--regular, .price__regular .price-item');
//   if (priceElement && variant.price) {
//     const formattedPrice = new Intl.NumberFormat('vi-VN', {
//       style: 'currency',
//       currency: 'USD'
//     }).format(variant.price / 100);
//     priceElement.textContent = formattedPrice;
//   }
  
//   const links = gridItem.querySelectorAll('a');
//   links.forEach(link => {
//     const baseUrl = product.url.split('?')[0];
//     link.href = `${baseUrl}?variant=${variant.id}`;
//   });
  
//   gridItem.setAttribute('data-color-variant', color);
//   gridItem.setAttribute('data-product-id', product.id);
// }

// ============================================
// SHOPIFY: Display variants in separate colors
// ============================================

(function() {
  'use strict';
  
  const CONFIG = {
    gridItemSelector: 'body.collection .grid__item',
    
    productLinkSelector: '.card__link, a.card-wrapper, a.card__media',
    
    imageSelector: '.card__media img, .media img',
    
    titleSelectors: [
      '.card__heading a',
      '.card__heading',
      '.card-information__text h3',
      '.card__information .card__heading'
    ],
    
    priceSelectors: [
      '.price-item--regular',
      '.price__regular .price-item',
      '.price .price-item',
      'span.price-item'
    ],
    
    // Option name color
    colorOptionNames: ['color', 'colour', 'pattern'],
    
    // Option name size
    sizeOptionNames: ['size'],
    
    currency: 'USD',
    locale: 'en-US',
    
    appendColorToTitle: true,
    
    titleSeparator: ' - ',
    
    debug: true
  };
  
  function log(...args) {
    if (CONFIG.debug) {
      console.log('[Split Variants]', ...args);
    }
  }
  
  function querySelector(element, selectors) {
    if (typeof selectors === 'string') {
      return element.querySelector(selectors);
    }
    for (const selector of selectors) {
      const el = element.querySelector(selector);
      if (el) return el;
    }
    return null;
  }
  
  function formatPrice(cents) {
    return new Intl.NumberFormat(CONFIG.locale, {
      style: 'currency',
      currency: CONFIG.currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(cents / 100);
  }
  
  function findOptionIndex(options, optionNames) {
    return options.findIndex(opt => {
      const optLower = opt.name.toLowerCase();
      return optionNames.some(name => optLower.includes(name));
    });
  }
  
  function groupVariantsByColor(variants, colorIndex) {
    const groups = new Map();
    
    variants.forEach(variant => {
      const color = variant.options[colorIndex];
      if (!groups.has(color)) {
        groups.set(color, []);
      }
      groups.get(color).push(variant);
    });
    
    return groups;
  }
  
  function updateVariantSelector(gridItem, variants, product, colorIndex, sizeIndex) {
    const variantSelect = gridItem.querySelector('.variant-select');
    if (!variantSelect) {
      log('No variant selector found');
      return;
    }
    
    // remove old options
    variantSelect.innerHTML = '';
    
    // Create new options only size
    variants.forEach((variant, index) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.setAttribute('data-price', variant.price);
      
      if (variant.compare_at_price) {
        option.setAttribute('data-compare-price', variant.compare_at_price);
      }
      
      // Only show size (or the remaining option after removing the color)
      if (sizeIndex !== -1) {
        // If there is a separate size option, only show size
        option.textContent = variant.options[sizeIndex];
      } else if (product.options.length === 1) {
        // If there is only 1 option (color), no dropdown is needed
        option.textContent = 'Default';
      } else {
        // If there are more options, show non-color options
        const optionTexts = variant.options
          .filter((opt, idx) => idx !== colorIndex)
          .join(' / ');
        option.textContent = optionTexts || 'Default';
      }
      
      // Set selected for first option
      if (index === 0) {
        option.selected = true;
      }
      
      // Mark if out of stock
      if (!variant.available) {
        option.textContent += ' - Sold Out';
        option.disabled = true;
      }
      
      variantSelect.appendChild(option);
    });
    
    log('Updated variant selector with', variants.length, 'options');
    
    // Hide dropdown if there is only 1 variant
    const variantWrapper = gridItem.querySelector('.variant-selector-wrapper');
    if (variantWrapper && variants.length === 1) {
      variantWrapper.style.display = 'none';
    }
  }
  
  function updateGridItem(gridItem, product, variants, colorName, colorIndex, sizeIndex) {
    // Get thumnail of variant (first variant of this color)
    const representativeVariant = variants[0];
    
    // Update image product
    const img = gridItem.querySelector(CONFIG.imageSelector);
    if (img && representativeVariant.featured_image) {
      img.src = representativeVariant.featured_image.src;
      img.srcset = representativeVariant.featured_image.src;
      
      if (CONFIG.appendColorToTitle) {
        img.alt = `${product.title} - ${colorName}`;
      }
    }
    
    // Update title product
    if (CONFIG.appendColorToTitle) {
      const titleElement = querySelector(gridItem, CONFIG.titleSelectors);
      if (titleElement) {
        const newTitle = `${product.title}${CONFIG.titleSeparator}${colorName}`;
        
        if (titleElement.tagName === 'A') {
          titleElement.textContent = newTitle;
        } else {
          const titleLink = titleElement.querySelector('a');
          if (titleLink) {
            titleLink.textContent = newTitle;
          } else {
            titleElement.textContent = newTitle;
          }
        }
      }
    }
    
    // Update price
    const priceElement = querySelector(gridItem, CONFIG.priceSelectors);
    if (priceElement && representativeVariant.price) {
      priceElement.textContent = formatPrice(representativeVariant.price);
    }
    
    // Update variant selector to only show sizes of this color
    updateVariantSelector(gridItem, variants, product, colorIndex, sizeIndex);
    
    // Update links
    const baseUrl = product.url.split('?')[0];
    const variantUrl = `${baseUrl}?variant=${representativeVariant.id}`;
    
    gridItem.querySelectorAll('a').forEach(link => {
      link.href = variantUrl;
    });
    
    // Add data attributes
    gridItem.setAttribute('data-color-variant', colorName);
    gridItem.setAttribute('data-product-id', product.id);
    gridItem.setAttribute('data-variant-id', representativeVariant.id);
    
    return gridItem;
  }
  
  async function processGridItem(gridItem) {
    try {
      const link = gridItem.querySelector(CONFIG.productLinkSelector);
      if (!link) {
        log('No product link found in grid item');
        return;
      }
      
      const productUrl = link.href.split('?')[0];
      const productHandle = productUrl.split('/products/')[1];
      
      if (!productHandle) {
        log('Could not extract product handle from:', link.href);
        return;
      }
      
      log('Processing product:', productHandle);
      
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const product = await response.json();
      log('Product data:', product);
      log('Product options:', product.options);
      
      // Find the index of the color option
      const colorIndex = findOptionIndex(product.options, CONFIG.colorOptionNames);
      
      if (colorIndex === -1) {
        log('No color option found for:', product.title);
        return;
      }
      
      // Find the index of the option size (if any)
      const sizeIndex = findOptionIndex(product.options, CONFIG.sizeOptionNames);
      
      log('Color option index:', colorIndex);
      log('Size option index:', sizeIndex);
      
      // Group variants by color (each color has many variants - sizes)
      const colorGroups = groupVariantsByColor(product.variants, colorIndex);
      log('Color groups:', Array.from(colorGroups.keys()));
      
      if (colorGroups.size <= 1) {
        log('Only one color variant, updating dropdown to hide color');
        // Only 1 color, no separation but still update dropdown to hide color
        const singleColor = Array.from(colorGroups.keys())[0];
        const colorVariants = colorGroups.get(singleColor);
        updateVariantSelector(gridItem, colorVariants, product, colorIndex, sizeIndex);
        return;
      }
      
      const colors = Array.from(colorGroups.keys());
      const parentElement = gridItem.parentNode;
      const nextSibling = gridItem.nextSibling;
      
      colors.forEach((color, index) => {
        const colorVariants = colorGroups.get(color);
        
        if (index === 0) {
          // Update first grid item
          updateGridItem(gridItem, product, colorVariants, color, colorIndex, sizeIndex);
        } else {
          // Clone and create new grid item
          const newGridItem = gridItem.cloneNode(true);
          updateGridItem(newGridItem, product, colorVariants, color, colorIndex, sizeIndex);
          
          // Add to DOM
          if (nextSibling) {
            parentElement.insertBefore(newGridItem, nextSibling);
          } else {
            parentElement.appendChild(newGridItem);
          }
        }
      });
      
      log(`Successfully split product "${product.title}" into ${colors.length} color variants`);
      
    } catch (error) {
      console.error('[Split Variants] Error processing grid item:', error);
    }
  }
  
  async function init() {
    log('Initializing Split Variants script...');
    
    const gridItems = document.querySelectorAll(CONFIG.gridItemSelector);
    log(`Found ${gridItems.length} grid items`);
    
    if (gridItems.length === 0) {
      console.warn('[Split Variants] No grid items found. Check CONFIG.gridItemSelector');
      return;
    }
    
    const promises = Array.from(gridItems).map(item => processGridItem(item));
    await Promise.all(promises);
    
    log('All products processed!');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();